export  const dateFormatter = (dateString) => {
    const date = new Date(dateString);

    // Get the Date part: "Dec 23, 2025"
    const datePart = date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });

    // Get the Time part: "9:21 PM"
    const timePart = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    // Combine and replace the comma after the day with your bullet point
    return `${datePart.replace(',', ' •')} ${timePart}`;
  };